import { Layout } from 'antd'
import { styled } from 'styled-components'

import { colors } from 'src/styles/theme'

export const StyledMain = styled(Layout)`
  /* Ensure the main area takes exactly the viewport height and hides its own scroll bar */
  height: 100vh;
  overflow: hidden;
  background-color: ${colors.neutral200} !important;
`

export const StyledContent = styled(Layout.Content)`
  margin: 0;
  padding: 0;
`

export const StyledMobileContent = styled.div<{ $withHeader?: boolean }>`
  height: 100vh;
  width: 100%;
  padding-top: env(safe-area-inset-top);
  overflow: hidden;

  /* Space for the bottom TabBar on mobile + iOS safe area */
  @media (max-width: 900px) {
    padding-bottom: calc(56px + env(safe-area-inset-bottom));
    ${({ $withHeader }) =>
      $withHeader &&
      `
        padding-top: calc(56px + env(safe-area-inset-top));
      `}
  }
`
